var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container fee-info-page" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _vm.showReceivable
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("feeTab.receivable"),
                    name: "receivable",
                    lazy: "",
                  },
                },
                [
                  _c("ReceivablePage", {
                    attrs: {
                      "fee-item-list": _vm.QUOTATION_FEE_ITEM,
                      "charge-unit-list": _vm.QUOTATION_CHARGE_UNIT,
                      "outer-order-no": _vm.outerOrderNo,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.showPayable
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("feeTab.payable"),
                    name: "payable",
                    lazy: "",
                  },
                },
                [
                  _c("PayablePage", {
                    attrs: {
                      "fee-item-list": _vm.QUOTATION_FEE_ITEM,
                      "charge-unit-list": _vm.QUOTATION_CHARGE_UNIT,
                      "outer-order-no": _vm.outerOrderNo,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }